
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M511 274.97c0 42.901-23.849 81.504-61.895 108.655v91.22l-98.182-53.508a253.752 253.752 0 01-34.776 2.412c-90.009 0-165.72-46.615-188.1-109.94l-71.75 39.112v-81.493C22.303 247.177 1 212.69 1 174.368c0-73.4 77.929-137.213 174.064-137.213 74.585 0 138.032 38.474 162.794 89.979C435.252 135.383 511 198.408 511 274.97zM175.069 67.097c-79.971 0-142.642 48.022-142.642 107.263 0 34.166 21.635 64.531 55.232 84.173l-1.865 44.524 35.73-21.104c-.14-2.314-.23-4.641-.23-6.983 0-79.175 81.011-143.877 183.192-148.486-23.742-35.185-72.705-59.387-129.417-59.387zm141.074 87.788c-89.517 0-162.092 53.758-162.092 120.075 0 66.314 72.576 120.074 162.092 120.074 17.294 0 33.924-2.046 49.545-5.761l50.389 29.76.333-49.841c37.605-21.995 61.823-55.983 61.823-94.232-.001-66.316-72.57-120.075-162.09-120.075z"}}),_c('path',{attrs:{"d":"M244.387 270.463c9.818 0 17.771 7.953 17.771 17.771 0 9.819-7.953 17.777-17.771 17.777s-17.777-7.958-17.777-17.777c0-9.818 7.958-17.771 17.777-17.771zM310.88 270.463c9.817 0 17.775 7.953 17.775 17.771 0 9.819-7.958 17.777-17.775 17.777-9.813 0-17.772-7.958-17.772-17.777-.001-9.818 7.958-17.771 17.772-17.771zM376.011 270.463c9.813 0 17.771 7.953 17.771 17.771 0 9.819-7.958 17.777-17.771 17.777-9.819 0-17.776-7.958-17.776-17.777-.001-9.818 7.956-17.771 17.776-17.771z"}})])])
          )
        }
      }
    